import { ArgsType, Field, Int } from '@nestjs/graphql'
import { MaxLength } from '@nestjs/class-validator'

@ArgsType()
export class ArcTeamBlockUserArgs {
  @Field(t => Int)
  statusReasonType!: number

  @Field(t => Int, { nullable: true })
  userId?: number

  @Field(t => Int, { nullable: true })
  memberId?: number

  @Field(t => Int, { nullable: true })
  arcId?: number

  @Field(t => Int, { nullable: true })
  arcTeamId?: number

  @Field({ nullable: true })
  @MaxLength(300, { message: 'maxLength' })
  statusReason?: string

  @Field({ nullable: true })
  report?: boolean

  @Field(t => Int, { nullable: true })
  claimId?: number
}
